import {
  clockInRequest,
  normalizeScoreRow
} from './client'

export async function getScores(params = {}) {
  const res = await clockInRequest({
    url: '/getScoreBoard',
    method: 'GET',
    params: {
      page: params.page || 1,
      pageSize: params.pageSize || 200,
      dept: params.dept,
      keyword: params.keyword
    }
  })
  const list = (res.data || []).map(normalizeScoreRow)
  return list.sort((a, b) => b.score - a.score)
}

export async function updateScore(row, payload = {}) {
  if (!row || !row.user_id) {
    throw new Error('缺少要更新的用户信息')
  }
  const res = await clockInRequest({
    url: '/updateScoreBoard',
    method: 'POST',
    data: {
      UserId: row.user_id,
      UserName: row.name,
      DeptName: row.dept || row.area,
      DeptId: row.raw?.DeptId || '',
      Avatar: row.avatar || row.raw?.Avatar || '',
      Area: row.area || row.dept || row.raw?.Area || '',
      ForwardRate: payload.forward_rate,
      SelectedClues: payload.selected_clues,
      ForwardWeight: payload.forward_weight || 0.4,
      ClueWeight: payload.clue_weight || 0.6,
      Metadata: row.raw?.Metadata || {}
    }
  })
  return normalizeScoreRow(res.data || {})
}